module.exports = __webpack_public_path__ + "static/gallery-24-21b1f9a4b2db6f1e20982531b261c48a.jpg";